import {Button} from "@root/server/client/esweb/components/ui/button.tsx";
import {ChevronRight, Save, Send, SendHorizonal} from "lucide-react";
import React from "react";


export const ContinueSubmitButton = (params: {isSubmitting?: boolean, canSubmit?: boolean}) => {
    const {
        isSubmitting,
        canSubmit = true
    } = params;

    return <Button type="submit" size="lg" className="w-full" disabled={isSubmitting || !canSubmit}>
        {isSubmitting ? "Saving..." : "Continue"}
        <ChevronRight/>
    </Button>
}


export const SendSubmitButton = (params: {isSubmitting?: boolean, canSubmit?: boolean, label?: string}) => {
    const {
        isSubmitting,
        canSubmit = true,
        label = 'Send'
    } = params;

    return <Button type="submit" size="lg" className="w-full" disabled={isSubmitting || !canSubmit}>
        {isSubmitting ? "Sending..." : label}
        <SendHorizonal/>
    </Button>
}


export const SaveSubmitButton = (params: {isSubmitting?: boolean, canSubmit?: boolean, label?: string, loadingLabel?: string}) => {
    const {
        isSubmitting,
        canSubmit = true,
        label = 'Save',
        loadingLabel = 'Saving...'
    } = params;

    return <Button type="submit" size="lg" className="w-full" disabled={isSubmitting || !canSubmit}>
        <Save/>
        {isSubmitting ? loadingLabel : label}
    </Button>
}